import  { createContext, useContext, useState, useEffect } from 'react';
import { getCurrentUser } from '../services/authService';
import toast from 'react-hot-toast';

// ایجاد Context برای احراز هویت
const AuthContext = createContext();

// Hook برای استفاده از AuthContext
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth باید داخل AuthProvider استفاده شود');
  }
  return context;
};

// Provider برای احراز هویت
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // بررسی توکن در localStorage
  useEffect(() => {
    const token = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');

    if (token && savedUser) {
      try {
        const userData = JSON.parse(savedUser);
        setUser(userData);
        setIsAuthenticated(true);
      } catch (error) {
        console.error('خطا در پارس کردن اطلاعات کاربر:', error);
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
    }
    
    setLoading(false);
  }, []);

  // دریافت اطلاعات کاربر از سرور
  const fetchUser = async () => {
    try {
      const response = await getCurrentUser();
      const userData = response.data;
      
      setUser(userData);
      setIsAuthenticated(true);
      localStorage.setItem('user', JSON.stringify(userData));
      
      return userData;
    } catch (error) {
      console.error('خطا در دریافت اطلاعات کاربر:', error);
      logout();
      throw error;
    }
  };

  // ورود کاربر
  const login = (userData, token) => {
    setUser(userData);
    setIsAuthenticated(true);
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    toast.success('ورود موفقیت‌آمیز');
  };

  // خروج کاربر
  const logout = () => {
    setUser(null);
    setIsAuthenticated(false);
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    toast.success('خروج موفقیت‌آمیز');
  };

  // بروزرسانی اطلاعات کاربر
  const updateUser = (userData) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  // بررسی دسترسی بر اساس نقش
  const hasRole = (role) => {
    return user?.role === role;
  };

  // بررسی دسترسی بر اساس نقش‌ها
  const hasAnyRole = (roles) => {
    return roles.includes(user?.role);
  };

  // بررسی دسترسی برای مدیران
  const isAdmin = () => {
    return hasRole('admin') || hasRole('manager');
  };

  // بررسی دسترسی برای مدیر کل
  const isManager = () => {
    return hasRole('manager');
  };

  // بررسی دسترسی برای مشاوران
  const isConsultant = () => {
    return hasRole('consultant');
  };

  // بررسی دسترسی برای مراجعان
  const isClient = () => {
    return hasRole('client');
  };

  const value = {
    user,
    loading,
    isAuthenticated,
    login,
    logout,
    updateUser,
    fetchUser,
    hasRole,
    hasAnyRole,
    isAdmin,
    isManager,
    isConsultant,
    isClient,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}; 